import {
  Box,
  Button,
  Flex,
  Select,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import MaterialTable, { MTableToolbar } from "material-table";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { LoginActivity, LoginActivityGroupByStudent } from "types/apiTypes";
import createPersistedState from "use-persisted-state";
import { api } from "../../config";
import LoginActivityModal from "./LoginActivityModal";

const ViewLoginActivities: React.FC = () => {
  const useCounterState = createPersistedState("sortQueryLoginActivity");
  const [sortQueryLoginActivity, setSortQueryLoginActivity]: any =
    useCounterState("id:asc");
  const tableRef = React.useRef(null);
  const history = useHistory();
  const toast = useToast();
  const [openModal, setOpenModal] = React.useState(false);
  const [LoginActivity, setLoginActivity] = React.useState<LoginActivity[]>();
  // const isClient = getRole() === "Client";
  const [isLargerThanMd] = useMediaQuery("(min-width: 48em)");
  const [groups, setGroups] = React.useState([]);
  const [selectedGroup, setSelectedGroup] = React.useState("");

  const fetchLoginActivitiesAndCount = async (
    start: number,
    limit: number,
    sort: any,
    LoginActivityName: string
  ) => {
    try {
      console.log(selectedGroup);
      const query =
        selectedGroup === ""
          ? `get-users?_limit=${limit}&_start=${start}`
          : `get-users-by-group?groupid=${selectedGroup}&_limit=${limit}&_start=${start}`;
      const response = await axios.get(`${api}/logindata/${query}`, {
        withCredentials: true,
      });
      console.log(response.data);
      const LoginActivities = response.data.data;
      const totalCount = response.data.count;

      return { LoginActivities, totalCount };
    } catch (error: any) {
      toast({
        title: error.message,
        position: "bottom-right",
        status: "error",
      });
      return { LoginActivities: [], totalCount: 0 };
    }
  };

  const handleAllUsersClick = () => {
    setSelectedGroup("");
    // @ts-ignore
    tableRef.current.onQueryChange();
  };

  const getGroups = async () => {
    try {
      const res = await axios.get(`${api}/groups`, { withCredentials: true });
      const mappedGroups = res.data;
      setGroups(mappedGroups);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleEditClick = async (rowData: any) => {
    try {
      console.log(rowData);
      const data = await axios.get(
        `${api}/logindata?users_permissions_user=${rowData.userid}`,
        { withCredentials: true }
      );
      setLoginActivity(data.data);
      setOpenModal(true);
    } catch (error) {
      console.log(error);
    }

    // console.log(rowData);
  };

  const onChangeGroup = async (e: any) => {
    setSelectedGroup(e.target.value);
    // @ts-ignore
    tableRef.current.onQueryChange();
  };
  React.useEffect(() => {
    getGroups();
  }, []);

  return (
    <>
      <Box px="2" py="2" display="flex">
        <Button
          variant="solid"
          onClick={handleAllUsersClick}
          p={2}
          bg={selectedGroup === "" ? "#f6ad55" : ""}
          color={selectedGroup === "" ? "white" : "black"}
          flex="1"
        >
          View All Students
        </Button>
        <Select
          placeholder="View Students by class"
          onChange={(e) => onChangeGroup(e)}
          textColor={selectedGroup !== "" ? "white" : "black"}
          flex="1"
          style={{
            backgroundColor: selectedGroup !== "" ? "#f6ad55" : "white",
          }}
        >
          {groups.map((group: any) => (
            <option
              key={group.id}
              value={group.id}
              style={{
                backgroundColor: selectedGroup !== "" ? "#f6ad55" : "white",
              }}
            >
              {`${group.id}-${group.groupName}`}
            </option>
          ))}
        </Select>
      </Box>
      <Flex flexDirection="row" px="2">
        <Box style={{ flexGrow: 4 }}>
          <MaterialTable
            tableRef={tableRef}
            title="Login Activities"
            columns={[
              { title: "Codice", field: "username", sorting: false },
              { title: "Email", field: "email", sorting: false },
              { title: "Phone", field: "phone", sorting: false },
              { title: "Device count", field: "devicecount", sorting: false },
              { title: "UserId", field: "userid", hidden: true },
            ]}
            components={{
              Toolbar: (props) => (
                <Box display="flex" w="100%" justifyContent="space-between">
                  <Box flex="1">
                    <MTableToolbar {...props} />
                  </Box>
                  {/* <MaterialTableCustomSort
                  sort={sortQueryLoginActivity}
                  setSort={setSortQueryLoginActivity}
                  materialTableRef={tableRef}
                  columns={columns}
                /> */}
                </Box>
              ),
            }}
            options={{
              actionsColumnIndex: -1,
              sorting: false,
              headerStyle: {
                zIndex: "unset",
              },
              rowStyle: (rowData: any) => ({
                backgroundColor: "white",
              }),
              search: false,
            }}
            onRowClick={(event, rowData: any) => handleEditClick(rowData)}
            data={(query) =>
              new Promise((resolve, reject) => {
                fetchLoginActivitiesAndCount(
                  query.page * query.pageSize,
                  query.pageSize,
                  sortQueryLoginActivity,
                  query.search
                )
                  .then(({ LoginActivities, totalCount }) => {
                    const newData = LoginActivities.map(
                      (item: LoginActivityGroupByStudent) => ({
                        username: item.username,
                        email: item.email,
                        phone: item.phone,
                        devicecount: item.devicecount,
                        userid: item.userid,
                      })
                    );

                    return resolve({
                      data: newData,
                      page: query.page,
                      totalCount,
                    });
                  })
                  .catch((err) => console.log(err));
              })
            }
          />
        </Box>
      </Flex>
      <LoginActivityModal
        openModal={openModal}
        LoginActivity={LoginActivity}
        setOpenModal={setOpenModal}
      />
    </>
  );
};

export default ViewLoginActivities;
